module.exports = __webpack_public_path__ + "static/img/ai_bot.3c943953.png";